var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-progress" }, [
    _vm.isHide
      ? _c(
          "div",
          { staticClass: "progress-persent", style: { left: _vm.percentage } },
          [_vm._v(" " + _vm._s(_vm.percentage) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "progress", style: { width: _vm.percentage } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }